import api from '../api/gateway';
import { pollingGatewayStatusDataInterval, pollingGatewayStatusMaxDuration } from '../constants';

const getDefaultState = () => ({
  errorMessage: '',
  isLoading: false,
  isPolling: false,
  pollingIntervalId: null,
  data: null,
  activationData: null,
  lastGotDataAt: null,
  pollingStartedAt: 0,
  exceededMaxPollingDuration: false,
});

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    RESET_STATE(state) { Object.assign(state, getDefaultState()); },
    SET_ERROR_MESSAGE(state, errorMessage) { state.errorMessage = errorMessage; },
    CLEAR_ERROR_MESSAGE(state) { state.errorMessage = ''; },
    START_LOADING(state) { state.isLoading = true; },
    STOP_LOADING(state) { state.isLoading = false; },
    START_POLLING(state) {
      state.isPolling = true;
      state.pollingStartedAt = Date.now();
    },
    STOP_POLLING(state) { state.isPolling = false; },
    SET_DATA(state, data) {
      state.data = data;
      state.lastGotDataAt = Date.now();
    },
    SET_POLLING_INTERVAL_ID(state, pollingIntervalId) {
      state.pollingIntervalId = pollingIntervalId;
    },
    RESET_POLLING_INTERVAL_ID(state) { state.pollingIntervalId = null; },
    EXCEEDED_MAX_POLLING_DURATION(state) { state.exceededMaxPollingDuration = true; },
  },
  actions: {
    async getGatewayStatus(context, {
      token, shortId,
    }) {
      context.commit('CLEAR_ERROR_MESSAGE');
      if (!context.state.isPolling) {
        context.commit('START_LOADING');
      }
      try {
        const data = await api.getGatewayStatus(
          token,
          shortId,
        );
        context.commit('SET_DATA', data);
      } catch (error) {
        context.commit('SET_ERROR_MESSAGE', error.message);
      } finally {
        context.commit('STOP_LOADING');
      }
    },
    async startPolling(context, { token, shortId }) {
      context.commit('RESET_POLLING_INTERVAL_ID');
      if (pollingGatewayStatusDataInterval && !context.state.isPolling) {
        const pollingIntervalId = window.setInterval(async () => {
          try {
            // check whether max duration exceeded
            if (Date.now() - context.state.pollingStartedAt >= pollingGatewayStatusMaxDuration) {
              context.dispatch('stopPolling');
              context.commit('EXCEEDED_MAX_POLLING_DURATION');
            } else if (!context.state.isLoading) {
              await context.dispatch('getGatewayStatus', { token, shortId });
            }
          } catch (error) {
            // error
          }
        }, pollingGatewayStatusDataInterval);
        context.commit('START_POLLING');
        context.commit('SET_POLLING_INTERVAL_ID', pollingIntervalId);
      }
    },
    stopPolling(context) {
      window.clearInterval(context.state.pollingIntervalId);
      context.commit('STOP_POLLING');
      context.commit('RESET_POLLING_INTERVAL_ID');
    },
  },
  getters: {
  },
};
